class TabbedProductShowcase extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.tabButtons = Array.from(this.querySelectorAll('[data-tab-trigger]'));
    this.tabPanels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    this.previousButton = this.querySelector('[data-carousel-action="previous"]');
    this.nextButton = this.querySelector('[data-carousel-action="next"]');

    this.tabButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const nextIndex = Number.parseInt(button.dataset.tabTrigger || '0', 10);
        this.setActiveTab(nextIndex);
      });
    });

    this.previousButton?.addEventListener('click', () => {
      const slideshow = this.getActiveSlideshow();
      if (!slideshow) return;
      slideshow.select(slideshow.current - 1);
    });

    this.nextButton?.addEventListener('click', () => {
      const slideshow = this.getActiveSlideshow();
      if (!slideshow) return;
      slideshow.select(slideshow.current + 1);
    });

    this.addEventListener('slideshow:select', (event) => {
      const slideshow = this.getActiveSlideshow();
      if (!slideshow || event.target !== slideshow) return;
      this.updateNavigationState();
    });

    const defaultTab = Number.parseInt(this.dataset.defaultTab || '0', 10);
    this.setActiveTab(defaultTab, { animate: false });
  }

  setActiveTab(index, options = {}) {
    const safeIndex = Math.max(0, Math.min(index, this.tabPanels.length - 1));
    const { animate = false } = options;

    this.tabButtons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === safeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.tabIndex = isActive ? 0 : -1;
    });

    this.tabPanels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === safeIndex;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    this.dataset.activeTab = String(safeIndex);

    const activeSlideshow = this.getActiveSlideshow();
    if (activeSlideshow) {
      requestAnimationFrame(() => {
        activeSlideshow.select(activeSlideshow.current, undefined, { animate });
        this.updateNavigationState();
      });
    } else {
      this.updateNavigationState();
    }
  }

  getActivePanel() {
    return this.tabPanels.find((panel) => !panel.hidden) || null;
  }

  getActiveSlideshow() {
    return this.getActivePanel()?.querySelector('slideshow-component') || null;
  }

  updateNavigationState() {
    const slideshow = this.getActiveSlideshow();
    if (!slideshow) {
      if (this.previousButton) this.previousButton.disabled = true;
      if (this.nextButton) this.nextButton.disabled = true;
      return;
    }

    if (this.previousButton) this.previousButton.disabled = Boolean(slideshow.atStart);
    if (this.nextButton) this.nextButton.disabled = Boolean(slideshow.atEnd);
  }
}

if (!customElements.get('tabbed-product-showcase')) {
  customElements.define('tabbed-product-showcase', TabbedProductShowcase);
}
